/**Packages */
import React from 'react';
import { useHistory } from 'react-router-dom';

/* Helpers */
import { grafanaLog } from '../../../helpers/logger';
import { getCookie, isIE } from '../../../helpers/utils';
import { SIMULATOR_TYPES } from '../../../helpers/constants';
import { deleteItemFromLS } from '../../../helpers/localStorage';
import { handleAPIRequest } from '../../../helpers/handleAPIRequest';
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';
import { deleteItemFromSS, getItemFromSS } from '../../../helpers/sessionStorage';

/* Redux */
import { useDispatch, useSelector } from 'react-redux';

export const QuidHiddenForm = ({ children }) => {
    const { amount, payment, purpose, numberOfInstallments } = useSelector(state => state.currentSimulation);
    const { current: currentAmount } = amount;
    const { current: currentPayment } = payment;
    const { text: purposeText, code: purposeCode } = purpose;
    const { min: minNumberOfInstallments, max: maxNumberOfInstallments } = numberOfInstallments;
    
    const history = useHistory();

    const isFixedRateMod = () => {
        // da modificare quando introdurrò il tool per passare da "rata fissa" a "durata fissa"
        return true;
    }

    const setActionUrl = () => {
        return getItemFromSS('redirectUrl') || '';
    }

    const submitForm = function(formSelector) {
        const timestampLog = new Date().getTime();
        
        deleteItemFromSS('redirectUrl');
        deleteItemFromSS('redirectToken');
        deleteItemFromLS('homePage');

        const fullData = {
            token: getRedirectToken(),
            ocs: purposeCode?.toString(),
            numRate: isFixedRateMod ? maxNumberOfInstallments?.toString() : minNumberOfInstallments?.toString(),
            importo: getValuePerMultiplier(currentAmount).toString(),
            tabellaFinanziaria: getTableFormattedCodeForQuid()
        };

        const baseLog = `timestamp=${timestampLog} payloadRichiesta=${JSON.stringify(fullData)}`;

        grafanaLog(`${baseLog} evento="chiamata a ${getPartnerEndpoints("compass").api.checkIfSimulatorIsDown}" httpstatusrisposta="null" motivo="Tentando il redirect dell'utente corrente alla form"`, SIMULATOR_TYPES.COMPASS_ONE_MINUTE_SIMULATOR);
        
        if (isIE()) {
            grafanaLog(`${baseLog} evento="chiamata a ${getPartnerEndpoints("compass").api.checkIfSimulatorIsDown} non eseguita" httpstatusrisposta="500" motivo="Internet Explorer non abilitato"`, SIMULATOR_TYPES.COMPASS_ONE_MINUTE_SIMULATOR);
            window.location.href = '/offline/ds/dsoffline.html';
        } else {
            const form = window.$(`.${formSelector}`);
            //add unbind to permit form submit
            form.unbind('submit');
            const data = form.serialize();

            //console.log(data);
            
            const callbacks = {
                200: function(response) {
                    if (response.data === "OK" || sessionStorage.getItem("simulatorIsDown") === "false") {
                        grafanaLog(`${baseLog} evento="chiamata a ${getPartnerEndpoints("compass").api.checkIfSimulatorIsDown} riuscita" httpstatusrisposta="200" motivo="Il simulatore è online, mando l'utente sul form"`, SIMULATOR_TYPES.COMPASS_ONE_MINUTE_SIMULATOR);
                        form.submit();
                    } else {
                        grafanaLog(`${baseLog} evento="chiamata a ${getPartnerEndpoints("compass").api.checkIfSimulatorIsDown} fallita" httpstatusrisposta="200" motivo="Il simulatore non è online"`, SIMULATOR_TYPES.COMPASS_ONE_MINUTE_SIMULATOR);
                        //window.location.href = window.location.origin + "/fissa-appuntamento/?prodotto=1&utm_source=DS&utm_campaign=downDs&mediacode=4492";
                        window.location.href = window.location.origin + "/fa3/?utm_source=PRESTITO1MIN&utm_campaign=ResDailyMIN&mediacode=9047";
                    }
                },
                400: function(err = null) {
                    grafanaLog(`${baseLog} evento="chiamata a ${getPartnerEndpoints("compass").api.checkIfSimulatorIsDown} fallita" httpstatusrisposta="400" motivo="${err ? err : "La chiamata per controllare se il simulatore è online o meno è andata in 400"}"`, SIMULATOR_TYPES.COMPASS_ONE_MINUTE_SIMULATOR);
                    form.submit();
                },
                500: function(err = null) {
                    grafanaLog(`${baseLog} evento="chiamata a ${getPartnerEndpoints("compass").api.checkIfSimulatorIsDown} fallita" httpstatusrisposta="500" motivo="${err ? err : "La chiamata per controllare se il simulatore è online o meno è andata in 500"}"`, SIMULATOR_TYPES.COMPASS_ONE_MINUTE_SIMULATOR);
                    form.submit();
                },
                default: function(err = null) {
                    //501 = not implemented
                    grafanaLog(`${baseLog} evento="chiamata a ${getPartnerEndpoints("compass").api.checkIfSimulatorIsDown} fallita" httpstatusrisposta="501" motivo="${err ? err : "La chiamata per controllare se il simulatore è online o meno è andata in errore"}"`, SIMULATOR_TYPES.COMPASS_ONE_MINUTE_SIMULATOR);
                    form.submit();
                },
            };
            
            handleAPIRequest({
                method: "POST",
                url: getPartnerEndpoints("compass").api.checkIfSimulatorIsDown,
                data,
            }, callbacks);
        }
    }

    const handleSubmit = (e) => {
        submitForm("quid-form");
    }

    const getRedirectToken = () => {
        return getItemFromSS('redirectToken') || '';
    }

    const multiplier = 100;
    const getValuePerMultiplier = (currentValue = 0) => {
        return currentValue * multiplier;
    }

    const getTableFormattedCodeForQuid = () => {
        //return getPartnerEndpoints("compass").currentTables["compass"]['one_minute']['codes']['9XX_CODE'];
        return window[getPartnerEndpoints("compass").currentTables["compass"]['tassicfg_key']]['ONE_MINUTE']['9XX_CODE'];
    }

    //
    const childrenWithProps = React.Children.map(children, child => React.cloneElement(child, { submitEvent: handleSubmit }));

    return (
        <form 
            className="quid-form"
            action={setActionUrl()} 
            method="get"
        >
            <input type="hidden" name="token" value={getRedirectToken()}></input>
            <input type="hidden" name="ocs" value={purposeCode?.toString()}></input>
            <input type="hidden" name="numRate" value={isFixedRateMod ? maxNumberOfInstallments?.toString() : minNumberOfInstallments?.toString()}></input>
            <input type="hidden" name="importo" value={getValuePerMultiplier(currentAmount).toString()}></input>
            <input type="hidden" name="tabellaFinanziaria" value={getTableFormattedCodeForQuid()}></input>
            { childrenWithProps }
        </form>
    );
}